export enum PresentationTypeEnum {
  DomiciledPDF = 'Domiciliada - PDF',
  InformativePDF = 'Informativa - PDF',
  SacichNRCPDF = 'Sacich NRC - PDF',
  ClientPresentationPDF = 'Presentación cliente - PDF',
  ClientPresentationDAT = 'Presentación cliente - DAT',
  ToCompensatePDF = 'A compensar - PDF',
  RefundPDF = 'Devolución - PDF',
  FullDeferralPDF = 'Aplazamiento total - PDF',
  PartialDeferralPDF = 'Aplazamiento parcial - PDF',
  PercentageDeferralPDF = 'Aplazamiento 60-40 - PDF', 
  NegativePDF = 'Negativa - PDF',
  ResultZeroPDF = 'Resultado 0.00 - PDF'

}